import cx from "classnames";
import React from "react";

import { StrollersList } from "@/mk2/apps/strollers/components/StrollersList";
import { StrollerEntity, StrollerPhoto } from "@/mk2/apps/strollers/schemas";
import { LoadingState } from "@/mk2/reducers/loadingState";
import { HistoryLocationWithState } from "@/mk2/services/browserHistory";
import { STROLLER_NO_RESULTS, STROLLER_SIMILAR_STROLLERS } from "@/mk/autogenerated/translation";

import styles from "./SimilarStrollers.mscss";

interface OwnState {
    expanded: boolean;
}

interface OwnProps {
    className?: string;
    similars: StrollerEntity[];
    comparison: number[];
    loadingState: LoadingState;
    hasMore: boolean;
    count: number;
    strollerPreviewPhotoMap: Record<number, number>;
    photoObjectsMap: Record<number, StrollerPhoto>;
    onComparisonToggle(strollerId, location: HistoryLocationWithState);
    onLoadMore();
}

type Props = OwnProps;

export class SimilarStrollers extends React.Component<Props, OwnState> {
    constructor(props: Props) {
        super(props);
        this.state = {
            expanded: false,
        };
    }

    public render() {
        const {
            className,
            hasMore,
            count,
            strollerPreviewPhotoMap,
            photoObjectsMap,
            loadingState,
            onLoadMore,
            onComparisonToggle,
            comparison,
            similars,
        } = this.props;

        if (similars.length === 0) {
            return null;
        }

        return (
            <div className={cx(styles.SimilarStrollers, className)}>
                <div className={styles.SimilarStrollers__textBox}>
                    <h2 className={styles.SimilarStrollers__headline}>
                        {STROLLER_SIMILAR_STROLLERS}
                    </h2>
                </div>

                <StrollersList
                    loadingState={loadingState}
                    items={similars}
                    noResultMessage={STROLLER_NO_RESULTS}
                    comparison={comparison}
                    hasMore={hasMore}
                    count={count}
                    strollersPreviewPhotoMap={strollerPreviewPhotoMap}
                    variantsPreviewPhotoMap={{}}
                    photoObjectsMap={photoObjectsMap}
                    load={this.handleOnLoad}
                    loadNext={onLoadMore}
                    onComparisonToggle={onComparisonToggle}
                />
            </div>
        );
    }

    private handleOnLoad() {
        // a dummy fn, the first load of similar strollers (and also other data) is done by container's onLoad fn
        return;
    }
}
